<template>
  <EditFormDialog
    :formData="editBrandForm"

    :formType="'update'"
    :loading="editBrandFormVisible"
    @submitForm="editBrandSubmit"
    @closeDialog="closeDialog"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!--  <el-dialog title="新增/编辑品牌" :visible="addBrandFormVisible" :modal-append-to-body='false'>-->
    <!--    <el-dialog title="新增/编辑品牌" :formType="'carBrandAdd'" :visible.sync="addBrandFormVisible" :modal-append-to-body='true'>-->
    <el-form :model="editBrandForm" :rules="rules" ref="editBrandForm" size="mini" class="edit_form">
      <el-form-item :label="$t('zi-mu-fen-lei')" :label-width="formLabelWidth" prop="type">
        <el-input :placeholder="$t('zui-duo-zhi-neng-tian-xie-yi-ge-zi-fu')" v-model="editBrandForm.type" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('pin-pai-0')" :label-width="formLabelWidth" prop="brand">
        <el-input :placeholder="$t('pin-pai-0')" v-model="editBrandForm.brand" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="editBrandFormVisible = false">{{ $t('qu-xiao') }}</el-button>
      <el-button size="small" type="primary" @click.native="editBrandSubmit" :loading="editBrandSubmitLoading">{{ $t('que-ding') }}
      </el-button>
    </div>
    <!--  </el-dialog>-->
  </EditFormDialog>
</template>

<script>
    import Pagination from "../../../../../components/Pagination";
    import carApi from "../../../api/carApi";
    import EditFormDialog from '@/components/EditFormDialog'
    import {validateInput} from '../../../../../common/validator'

    export default {
        props: {

            selectRowData: {
                type: Object,
                required: true
            },
        },
        name: "edit",
        data() {
            return {
                views: {},
                enumData: [{
                    carTypeData: ''
                }],
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: '',
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                editModelForm: {},
                addBrandForm: {},
                editBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                editModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                editBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                editModelFormVisible: false,
                addBrandFormVisible: false,
                editBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                activeName: 'modelList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'modelList',
                rules:{
                  type: [
                    {required: true, message: this.$t('qing-tian-xie-zi-mu-fen-lei'), trigger: 'blur'},
                    {validator:function (rule, value, callback) {
                        validateInput(rule, value, callback,1,1,false,false,true,false,true,true,false)
                      }, required: true,trigger: 'blur'}
                  ],
                    brand: [
                        {validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,0,10,true,true,false,true,true,false,false)
                            }, required: true,trigger: 'blur'}],

                }
            }
        },
        watch: {
            selectRowData: {
                handler: function (selectRowData) {
                    this.editBrandForm = Object.assign({}, selectRowData)
                    // this.formData.state = selectRowData.state && selectRowData.state.code
                },
                immediate: false
            }
        },
        methods: {
            closeDialog(formType) {
                this.$refs["editBrandForm"].clearValidate()
                this.$emit("closeDialog", formType)
            },
            editBrandSubmit() {
              this.$refs["editBrandForm"].validate((valid) => {
                  if (!valid) {
                    return ;
                  } else {
                    //console.log(this.editBrandForm)
                    this.editBrandSubmitLoading = true
                    let param = JSON.stringify(this.editBrandForm)
                    carApi.saveOrUpdateBrand(param).then((res) => {
                      this.editBrandSubmitLoading = false
                      if (res.code === 0) {
                        this.$message({
                          // message: res.message,
                          type: 'success',
                          message: this.$t('ti-jiao-cheng-gong')
                        });
                        this.editBrandFormVisible = false
                        this.$emit('afterEdit')
                        // this.submitBrandSearchForm()
                      } else {
                        this.$message.error(res.message)
                      }
                    })
                  }
              })
            },
        },
        components: {
            Pagination,
            EditFormDialog
        },
        created: function () {

        },
        mounted: function () {


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/brand/edit.vue